/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'

const Icon = ({ theme, color }) => <svg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5ZM15 8.5C15 12.366 11.866 15.5 8 15.5C4.13401 15.5 1 12.366 1 8.5C1 4.63401 4.13401 1.5 8 1.5C11.866 1.5 15 4.63401 15 8.5ZM5.63127 8.1255C5.43601 7.93024 5.11943 7.93024 4.92417 8.1255C4.7289 8.32076 4.7289 8.63734 4.92417 8.83261L6.88967 10.7981C7.08302 10.9915 7.39582 10.9936 7.59184 10.803L11.0708 7.41932C11.2687 7.22679 11.2731 6.91023 11.0806 6.71228C10.8881 6.51433 10.5715 6.50993 10.3736 6.70246L7.2481 9.74233L5.63127 8.1255Z'
      fill={theme.colors[color]}/>
</svg>

Icon.propTypes = {
    theme: PropTypes.object,
    color: PropTypes.string,
}

export default withTheme(Icon)
